export const darkTheme = {
    bg:"#0a0a0a",
    bgLight: "#111111",
    primary:"#60a5fa",
    text_primary:"#f8fafc",
    text_secondary:"#94a3b8",
    card:"#1a1a1a",
    card_light: '#262626',
    button:"#60a5fa",
    white:"#ffffff",
    black:"#0a0a0a",
}

export const lightTheme = {
    bg:"#0a0a0a",
    bgLight: "#111111",
    primary:"#60a5fa",
    text_primary:"#f8fafc",
    text_secondary:"#94a3b8",
    card:"#1a1a1a",
    button:"#60a5fa",
}